module.exports = __webpack_public_path__ + "static/media/shopping_cart.3d8f712a.png";